import '../views/erroneousstatements/erroneousstatements.html';

import { ERRONEOUS_STMTS } from '../services/arsweb/RoutingPaths';

export const ERRONEOUS_STMTS_ROUTE = 'app.erroneousstatements';

export class ErroneousStatementsStates {
    /** @ngInject */
    constructor($stateProvider) {
        this.$stateProvider = $stateProvider;
    }

    defineStates() {
        this.$stateProvider.state(ERRONEOUS_STMTS_ROUTE, {
            url: ERRONEOUS_STMTS,
            templateUrl: './app/views/erroneousstatements/erroneousstatements.html',
            controller: 'CommonViewController',
            controllerAs: 'vm',
            params: {
                pageTitle: 'REPORTINGS',
            }
        });
    }
}
